import { render, staticRenderFns } from "./sonet-swiper-safe.vue?vue&type=template&id=3b2ef54b&scoped=true"
import script from "./sonet-swiper-safe.vue?vue&type=script&lang=js"
export * from "./sonet-swiper-safe.vue?vue&type=script&lang=js"
import style0 from "./sonet-swiper-safe.vue?vue&type=style&index=0&id=3b2ef54b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2ef54b",
  null
  
)

export default component.exports